@if (error$ | async) {
  <notification
    class="error-handler__notification"
    [text]="error$ | async"
    [closable]="true"
    [spacing]="false"
    (hide)="onHide()"
    [style.margin-top.px]="spacingTop"
    [style.margin-bottom.px]="spacingBottom"
  ></notification>
}
